export const ASAP_AUDIENCE = 'identity-platform';

export const PRODUCT_KEY_MAP = {
	CONFLUENCE: 'confluence.ondemand',
	JIRA_CORE: 'jira-core.ondemand',
	JIRA_BUSINESS: 'jira-core.ondemand',
	JIRA_SOFTWARE: 'jira-software.ondemand',
	JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
	BITBUCKET: 'com.atlassian.bitbucket',
	OPSGENIE: 'opsgenie',
	STATUSPAGE: 'statuspage',
	TRELLO: 'trello',
};
